import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { guestQuestionsKey } from '@dashboard/lib/queryKeys';
import { fetcher } from '@dashboard/services/request';

export const guestQuestionsPath = (sellerId, pageId) =>
  `/sellers/${sellerId}/pages/${pageId}/guest-questions`;

export default function useGuestQuestions(pageId, { enabled = true } = {}) {
  const { sellerId, token } = useAuth();
  return useQuery({
    queryKey: guestQuestionsKey(pageId),
    queryFn: () => fetcher(guestQuestionsPath(sellerId, pageId), token),
    enabled: Boolean(enabled && sellerId && token && pageId),
  });
}
